const isMerchant = window.location.pathname.includes("merchant");
const voucherTransactionPath = isMerchant
  ? "/voucherTransaction"
  : "/adminVoucherTransaction";

const allMenuItems = [
  {
    text: "Members",
    path: "/members",
    icon: "members",
    module: "Members",
    subModule: false,
    feature: "",
  },
  {
    text: "Dashboard",
    path: "/merchantDashboard",
    icon: "dashboard",
    module: "dashboard",
    subModule: false,
    feature: "Merchant Profile",
  },
  {
    text: "Merchants",
    path: "/viewMerchant",
    icon: "merchants",
    module: "Merchant",
    subModule: false,
    feature: "",
  },
  {
    text: "Voucher Transactions",
    path: voucherTransactionPath,
    icon: "voucherTransaction",
    module: "voucher_transactions",
    subModule: false,
    feature: "eVouchers",
  },
  {
    text: "Receipts",
    path: "/receipts",
    icon: "receipts",
    module: "Receipts",
    subModule: false,
    feature: "",
  },
  {
    text: "Pending Receipts",
    path: "/pending-receipts",
    icon: "pendingReceipts",
    module: "Receipts",
    subModule: false,
    feature: "",
  },
  {
    text: "Finance",
    path: "/finance",
    icon: "finance",
    module: "Finance",
    subModule: false,
    feature: "",
  },
  {
    text: "Finance Reports",
    path: "/finance-reports",
    icon: "finance-reports",
    module: "finance_reports",
    subModule: false,
    feature: "",
  },
  {
    text: "Admin",
    path: "/admin",
    icon: "admin",
    module: "Admin",
    subModule: false,
    feature: "",
  },
  {
    text: "Physical Voucher",
    path: "/uploadVoucher",
    icon: "physicalVouchers",
    module: "Physical Voucher",
    subModule: false,
    feature: "",
  },
  {
    text: "Flash Sale",
    path: "/flashSale_redirection",
    icon: "flashsale",
    module: "flash_sale_redirect",
    subModule: false,
    feature: "Flash Sale (Tenant Portal)",
  },
  {
    text: "Rewards",
    path: "/rewards_redirection",
    icon: "deals",
    module: "rewards_redirect",
    subModule: false,
    feature: "Deals (Tenant Portal)",
  },
  {
    text: "Promotions",
    path: "/promotions_redirection",
    icon: "campaign",
    module: "promotions_redirect",
    subModule: false,
    feature: "Promotions (Tenant Portal)",
  },
  {
    text: "Events",
    path: "/redirected",
    icon: "events",
    module: "Events",
    subModule: false,
    feature: "",
  },
  {
    text: "Member Redemption",
    path: "/search/memberRedemption",
    icon: "merchants",
    module: "Member Redemption",
    subModule: false,
    feature: "",
  },
  {
    text: "Sales",
    path: "/search/sales",
    icon: "sales",
    module: "sale_of_voucher",
    subModule: false,
    feature: "",
  },

  {
    text: "Physical Voucher Reimbursement",
    path: "/physicalVoucher",
    icon: "physicalVouchers",
    module: "physical_voucher_reimbursement",
    subModule: false,
    feature: "Submitted Physical Vouchers",
  },
  {
    text: "e-Voucher Reimbursement",
    path: "/eVoucher",
    icon: "eVoucher",
    module: "evoucher_reimbursement",
    subModule: false,
    feature: "e-Voucher Reimbursement",
  },
  {
    text: "Flash Sale",
    path: "/flashsale",
    icon: "flashsale",
    module: "flash_sale",
    subModule: false,
    feature: "Flash Sale (Tenant Portal)",
  },
  {
    text: "Rewards",
    path: "/deals",
    icon: "deals",
    module: "rewards",
    subModule: false,
    feature: "Deals (Tenant Portal)",
  },
  {
    text: "Promotions",
    path: "/promotions",
    icon: "campaign",
    module: "promotions",
    subModule: false,
    feature: "Promotions (Tenant Portal)",
  },

  {
    text: "User Access",
    path: "/userAccess",
    icon: "admin",
    module: "user_access",
    subModule: false,
    feature: "Shop User",
  },

  {
    text: "Configuration",
    path: "/redirected",
    icon: "configuration",
    module: "Configuration",
    subModule: true,
    feature: "",
  },
  {
    text: "Feedback",
    path: "/redirected",
    icon: "feedback",
    module: "Feedback",
    subModule: false,
    feature: "",
  },
];

// Filter out Pending Receipts for merchant portal
export const sideMenuList = isMerchant
  ? allMenuItems.filter((item) => item.text !== "Pending Receipts")
  : allMenuItems;
